import React from 'react';  
  
const LoadingScreen = () => {  
  return (  
    <div className="h-screen flex items-center justify-center">  
      <div className="text-center">  
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>  
        <p className="mt-4">Loading...</p>  
      </div>  
    </div>  
  );  
};  
  
export default LoadingScreen;